<template>
    <div>
        <b-table-simple>
            <b-thead>
            </b-thead>
            <b-tbody>
                <b-tr>
                    <b-td style="width:30%;">파이프라인 사용 여부</b-td>
                    <b-td>
                        <b-dropdown :text="pipeline_enabled? '사용' : '사용하지 않음'">
                            <b-dropdown-item @click="enablePipeline(true)">사용</b-dropdown-item>
                            <b-dropdown-item @click="enablePipeline(false)">사용하지 않음</b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
                <b-tr v-if="pipeline_enabled==true">
                    <b-td>대상 SubCode</b-td><b-td><b-form-input v-model="pipeline_sub_code"></b-form-input></b-td>
                </b-tr>
                <b-tr v-if="pipeline_enabled==true">
                    <b-td>상세조건</b-td><b-td><b-form-textarea v-model="condition" max-rows="10" ></b-form-textarea></b-td>
                </b-tr>
                <b-tr v-if="pipeline_enabled==true">
                    <b-td col-span="2">조건이 참일 경우 해당 질문을 
                    </b-td>
                    <b-td>
                        <b-dropdown :text="satisfied_visible? '표시함' : '표시하지 않음'">
                            <b-dropdown-item @click="satisfied_visible=true">표시함</b-dropdown-item>
                            <b-dropdown-item @click="satisfied_visible=false">표시하지 않음</b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
                <b-tr v-if="pipeline_enabled==true">
                    <b-td col-span="2">질문이 표시되지 않는 경우 해당 질문을 
                    </b-td>
                    <b-td>
                        <b-dropdown :text="invisible_not_applicable? '해당없음 처리' : '0점 처리'">
                            <b-dropdown-item @click="invisible_not_applicable=true">해당없음 처리</b-dropdown-item>
                            <b-dropdown-item @click="invisible_not_applicable=false">0점 처리</b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <div class="text-right">
            <b-button variant="blue" class="mr-2" @click="handleSave">저장</b-button>
            <b-button variant="dark" @click="$emit('click-cancel')">취소</b-button>
        </div> 
    </div>
</template>

<script>
export default {
    name: "EditingPipeline",
    props: {
        sub_code: {
            type: String,
            default: ''
        },
        sub_type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            pipeline_enabled: false,
            pipeline_sub_code: '',
            condition: '',
            satisfied_visible: false,
            invisible_not_applicable: true
        }
    },
    async created () {
        await this.readPipeline()
    },
    methods:{
        async readPipeline () {
            try {
                const response = await this.$axios.get('/read_pipeline', {
                    params: { sub_code: this.sub_code }
                })

                console.log(response)
                if (response.data) this.pipeline_enabled = true
                this.pipeline_sub_code = response.data.pipeline_sub_code
                this.condition = response.data.condition
                this.satisfied_visible = response.data.satisfied_visible
                this.invisible_not_applicable = response.data.invisible_not_applicable   
            } catch (error) {
                console.log(error);
            }
        },
        async handleSave () {
            if (this.pipeline_enabled === false) {
                await this.deletePipeline()
            } else {
                await this.savePipeline()
            }
        },
        async deletePipeline () {
            const formData = new FormData()
            formData.append('sub_code', this.sub_code)
            await this.$axios.post('/delete_pipeline', formData)
            // const path = this.$store.state.backend_host + '/delete_pipeline'

            // const formData = new FormData()
            // formData.append('sub_code', this.sub_code)

            // return axios.post(path, formData)
        },
        async savePipeline () {
            try {
                const formData = new FormData()
                formData.append('sub_code', this.sub_code)
                formData.append('pipeline_sub_code', this.pipeline_sub_code)
                formData.append('condition', this.condition)
                formData.append('satisfied_visible', this.satisfied_visible )
                formData.append('invisible_not_applicable', this.invisible_not_applicable)

                const response = await this.$axios.post('/save_pipeline', formData)
                console.log(response)
                this.$emit('toast-success','성공','질문 숨김/표시 조건을 저장하였습니다.')
            } catch (error) {
                console.log(error)
            }
        
            // const path = this.$store.state.backend_host + '/save_pipeline'
                   
            // const formData = new FormData()
            // formData.append('sub_code', this.sub_code)
            // formData.append('pipeline_sub_code', this.pipeline_sub_code)
            // formData.append('condition', this.condition)
            // formData.append('satisfied_visible', this.satisfied_visible )
            // formData.append('invisible_not_applicable', this.invisible_not_applicable)

            // return axios.post(path, formData)
            // .then(response => {
            //     console.log(response)
            //     this.$emit('toast-success','성공','질문 숨김/표시 조건을 저장하였습니다.')               
            // })
            // .catch(error => {
            //     console.log(error)
            // })
        },
        enablePipeline(target){
            if(target==true){
                this.pipeline_enabled = true
            }
            else{
                this.pipeline_enabled = false
                this.pipeline_sub_code = ''
                this.condition = ''
                this.satisfied_visible = false,
                this.invisible_not_applicable = true
            }
        }

    }
}
</script>

<style>
/* #structure-preview > .card-header {
    padding: 0.25rem 1.25rem;
} */
#structure-preview > .card-body > .table td{
    text-align: left;
}
</style>